import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import masterService from 'services/MasterService';
export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const versionListAll = createAsyncThunk('/version/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getSize(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const versionSlice = createSlice({
    name: 'version',
    initialState,
    reducers: {

        versionList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(versionListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(versionListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})

export const {
    versionList
} = versionSlice.actions

export default versionSlice.reducer